export const mutations = {
  setLoggedUser(state, payload) {
    state.loggedUser = payload;
  },
  setToken(state, payload) {
    state.token = payload;
  },
  setModalForgotPassword(payload) {
    state.modalForgotPassword = payload;
  },
  setSponsor(state, payload) {
    state.sponsor = payload;
  }
};

export default {};
